import { HumanTension } from 'pages/BrandDetails/HumanTension'

import { FRAMEWORK_WHEEL_SECTIONS } from './frameworkWheelData'

export const FrameworkSection = () => (
  <div>
    <div className="pt-20 pb-16">
      <div className=" mx-auto">
        <p className="text-center title-xl pb-6 ">The BVA Framework</p>
        <p className="text-center pb-10 body-m w-full mx-auto max-w-[794px]">
          BVA 2.0 is composed of three key areas that add up to defining a Meaningful Brand Role. It’s a circular cycle,
          which means there’s no start or finish—you can enter from any point, depending on your brand’s needs.
        </p>
        <HumanTension sections={FRAMEWORK_WHEEL_SECTIONS} />
      </div>
    </div>
  </div>
)
